import React from 'react'
import { Steps } from 'antd'
import type { StepProps } from 'antd'

interface StatusJourneyProps {
    // The happy path, in order
    journey: string[]
    current: string
    labelOf: (status: string) => string
}

// Where the entity is on its happy path. Two-step journeys add nothing over the status tag, and statuses
// off the path (e.g. rejected) leave every step waiting rather than inventing a history
const StatusJourney: React.FC<StatusJourneyProps> = ({ journey, current, labelOf }) => {
    if (journey.length < 3) return null

    const index = journey.indexOf(current)
    const last = journey.length - 1
    const stepStatus = (position: number): StepProps['status'] => {
        if (index === -1 || position > index) return 'wait'
        if (position < index || position === last) return 'finish'
        return 'process'
    }

    return (
        <Steps
            className="status-journey"
            size="small"
            current={index}
            items={journey.map((status, position) => ({
                title: labelOf(status),
                status: stepStatus(position),
                description: position === index ? 'Current' : undefined,
            }))}
        />
    )
}

export default StatusJourney
